import axios from 'axios'

axios.defaults.headers.common.token = localStorage.token;
// axios.defaults.baseURL = 'http://192.168.88.115:8000/';
// axios.defaults.baseURL = 'http://87.255.194.52:8000';
axios.defaults.baseURL = 'https://new.idm-online.kz:8000/api/';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Content-Type'] = 'application/json';
